<template>
  <div class="public-content recharge-enquiry">
    <div class="breadcrumb"> {{ codeType !== 'free' ? '免单电子卡券记录' : '余额支付电子卡券记录' }}</div>
    <div class="right-main">
      <el-form :inline="true" :model="formInline" label-width="114px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品名称:">
              <el-input v-model="formInline.name" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="codeType !== 'free' ? '免单码:' : '余额支付码:'">
              <el-input v-model="formInline.promoCode" :placeholder="codeType !== 'free' ? '请输入免单码' : '请输入余额支付码'" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.promoStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="已生成" value="PRODUCED"></el-option>
                <el-option label="退款完成" value="REFUNDED"></el-option>
                <el-option label="部分退款完成" value="PARTIAL_REFUNED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否生成核销码:">
              <el-select v-model="formInline.verificationCode" clearable placeholder="请选择">
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开码日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" round>导出Excel</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column prop="spuName" label="产品名称" min-width="150"></el-table-column>
          <el-table-column prop="skuName" label="规格" min-width="180"></el-table-column>
          <el-table-column prop="sku.page" label="P数" min-width="180"></el-table-column>
          <el-table-column prop="store.code" label="平台号" min-width="120"></el-table-column>
          <el-table-column prop="store.name" label="平台名称" min-width="130"></el-table-column>
          <el-table-column prop="store.salesman.fullName" label="业务" min-width="120"></el-table-column>
          <el-table-column prop="quantity" label="数量" min-width="80"></el-table-column>
          <el-table-column prop="codeCount.countDownloaded" label="已下载" min-width="80">
            <template v-slot="scope"> {{ scope.row.codeCount ? scope.row.codeCount.countDownloaded : 0 }} </template>
          </el-table-column>
          <el-table-column label="未下载" min-width="80">
            <template v-slot="scope"> {{ scope.row.codeCount ? scope.row.quantity - scope.row.codeCount.countDownloaded - scope.row.codeCount.countDeleted - scope.row.codeCount.countUsed :
              scope.row.codeCount }} </template>
          </el-table-column>
          <el-table-column prop="codeCount.countUsed" label="已使用" min-width="80"></el-table-column>
          <el-table-column prop="codeCount.countDeleted" label="已删除" min-width="80" v-if="codeType === 'promo'"></el-table-column>
          <el-table-column prop="price" label="购买单价" min-width="80" v-if="codeType === 'promo'"></el-table-column>
          <el-table-column prop="amount" label="购买总价" min-width="80" v-if="codeType === 'promo'"></el-table-column>
          <el-table-column prop="amountBalance" label="余额" min-width="80" v-if="codeType === 'promo'"></el-table-column>
          <el-table-column prop="price" label="会员单价" min-width="80" v-if="codeType === 'free'"></el-table-column>
          <el-table-column label="状态" min-width="100">
            <template v-slot="scope"> {{ $config.promoStatusList[scope.row.promoStatus] }} </template>
          </el-table-column>
          <el-table-column label="是否生成核销码" min-width="100" prop="verificationCode">
            <template v-slot="scope"> {{ scope.row.verificationCode ? '是' : '否' }} </template>
          </el-table-column>
          <el-table-column prop="dateCreated" label="开码日期" min-width="170"></el-table-column>
          <el-table-column label="操作" min-width="50px">
            <template v-slot="scope">
              <!-- v-if="$hasPermission('psm:admin:promo:detail')" -->
              <span class="color-blue" @click="detail(scope.row)" ref="operationRef">查看<br></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { promoPage, promoExport } from '@/api/epay'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName } from '@/api/crm'
export default {
  name: 'promomanage',
  components: {
    VPagination
  },
  data () {
    return {
      storeListByCode: [],
      storeListByName: [],
      salemanList: [],
      auditedData: [],
      dialogVisible: false,
      storeName: '',
      code: '',
      fullName: '',
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      formInline: {
        dateEnd: '',
        dateStart: '',
        name: '', // 	产品名称
        promoCode: '', // 免单码
        promoStatus: '',
        salesmanId: '',
        skuId: '',
        storeId: '',
        promoKind: 'PROMO_ZERO_TYPE01'
      },
      tableData: [],
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        if (val) {
          this.formInline.dateStart = val[0]
          this.formInline.dateEnd = val[1]
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler: function (val, oldVal) {
        console.log(val, 'route')
        if (val.path.indexOf('freeElectronicCard') !== -1) {
          this.formInline.promoKind = 'FREE_ZERO_TYPE01'
          this.codeType = 'free'
        } else {
          this.formInline.promoKind = 'PROMO_ZERO_TYPE01'
          this.codeType = 'promo'
        }
        this.onSubmit()
      },
      // 深度观察监听
      deep: true
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.codeType = JSON.parse(sessionStorage.getItem('codeType'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
      this.value2 = [this.formInline.dateStart, this.formInline.dateEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('codeType')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    this.codeType = this.$route.path.indexOf('freeElectronicCard') !== -1 ? 'free' : 'promo'
    this.formInline.promoKind = this.$route.path.indexOf('freeElectronicCard') !== -1 ? 'FREE_ZERO_TYPE01' : 'PROMO_ZERO_TYPE01'
    this.onSubmit()
  },
  methods: {
    detail (val) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('codeType', JSON.stringify(this.codeType))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      this.$router.push({ path: '/epay/electronicaCouponDetail', query: { id: val.orderId, code: this.codeType } })
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('codeType', JSON.stringify(this.codeType))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      let param = JSON.parse(JSON.stringify(this.formInline))
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      promoPage({ page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize, descField: 'dateCreated', promoVO: param }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.content.map(res => {
            if (res.promoType === 'SPU') {
              return {
                ...res,
                spuName: res.name,
                skuName: ''
              }
            } else {
              return {
                ...res,
                skuName: res.sku.skuName,
                spuName: res.sku.spuName
              }
            }
          })
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },

    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      promoExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let dateStart = this.formInline.dateStart
          let dateEnd = this.formInline.dateEnd

          let name = this.codeType !== 'free' ? '免单电子卡券记录' : '余额支付电子卡券记录'
          // let _fileName = '电子卡券记录' + this.$moment(new Date()).format('YYYY-MM-DD') + '.xls'
          let _fileName = name + `${dateStart}-${dateEnd}` + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";
</style>
